import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestReorderUsageGuideFaqItems } from "./reorderUsageGuideFaqItems.request";
import { ReorderUsageGuideFaqItemsRequestBody } from "./reorderUsageGuideFaqItems.types";

const useReorderUsageGuideFaqItems = (
  options?: MutationOptions<
    void,
    ApiServiceError<ApiError>,
    ReorderUsageGuideFaqItemsRequestBody
  >
) => {
  const refetchUsageGuides = useRefetchQuery(["product-usage-guides"]);

  return useMutation({
    mutationFn: requestReorderUsageGuideFaqItems,
    ...options,
    // No success toast: the table already moved the row optimistically, and a
    // drag is not the kind of action that wants confirming.
    onSuccess: (data, variables, context) => {
      void refetchUsageGuides();
      options?.onSuccess?.(data, variables, context);
    },
    // The optimistic order is now a lie — refetch to snap back to the truth.
    onError: (error, variables, context) => {
      toastServerError(error);
      void refetchUsageGuides();
      options?.onError?.(error, variables, context);
    }
  });
};

export default useReorderUsageGuideFaqItems;
